import { createSlice } from "@reduxjs/toolkit"

const defaultPageDetails = { pageNo: 0, pageSize: 10 }

const initialState = {
  organizationsOrganizationsTableDetails: defaultPageDetails,
  organizationsOrganizationClinicsTableDetails: defaultPageDetails,
  organizationsOrganizationUsersTableDetails: defaultPageDetails,
  organizationsOrganizationClinicUsersTableDetails: defaultPageDetails,
}

const tableDetailsSlice = createSlice({
  name: "pageDetails",
  initialState,
  reducers: {
    updateOrganizationsOrganizationsTableDetails: (state, action) => {
      state.organizationsOrganizationsTableDetails = action.payload
    },
    updateOrganizationsOrganizationClinicsTableDetails: (state, action) => {
      state.organizationsOrganizationClinicsTableDetails = action.payload
    },
    updateOrganizationsOrganizationUsersTableDetails: (state, action) => {
      state.organizationsOrganizationUsersTableDetails = action.payload
    },
    updateOrganizationsOrganizationClinicUsersTableDetails: (state, action) => {
      state.organizationsOrganizationClinicUsersTableDetails = action.payload
    },
  },
})

export const {
  updateOrganizationsOrganizationsTableDetails,
  updateOrganizationsOrganizationClinicsTableDetails,
  updateOrganizationsOrganizationUsersTableDetails,
  updateOrganizationsOrganizationClinicUsersTableDetails,
} = tableDetailsSlice.actions

export default tableDetailsSlice.reducer
